import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormSwitch,
  title: 'Switch',
  category: ComponentCategory.FormControls,
};
